import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineFileDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={15}
    fill="none"
    viewBox="0 0 13 15"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M6.425 3.8v5.25M4.325 6.95l2.1 2.1 2.1-2.1M4.325 11.15h4.2"
    />
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M.65 1.7v11.55c0 .58.47 1.05 1.05 1.05h9.45c.58 0 1.05-.47 1.05-1.05V4.325L8.525.65H1.7C1.12.65.65 1.12.65 1.7Z"
    />
  </svg>
);
export default SvgStreamlineFileDownload;
